import { render, staticRenderFns } from "./Staffs.vue?vue&type=template&id=433a8b68"
import script from "./Staffs.vue?vue&type=script&lang=js"
export * from "./Staffs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports